import { SavePrintJobPaintsBody } from '../../../../../../../types/api/print-job-paints'
import { PaintRowDraft } from '../types'

export function toSaveBody(drafts: PaintRowDraft[], confirm: boolean): SavePrintJobPaintsBody {
    return {
        data: {
            confirm,
            rows: drafts.map(draft => ({
                formDocumentId: draft.form.documentId,
                pantoneName: draft.pantoneName,
                referencePantoneDocumentId: draft.referencePantoneDocumentId,
                manufacturerDocumentId: draft.manufacturerDocumentId,
                portions: draft.portions,
                colorants: draft.colorants.map(cell => ({
                    colorantDocumentId: cell.colorantDocumentId ?? null,
                    amount: cell.amount ?? null,
                })),
            })),
        },
    }
}
